module.exports = __webpack_public_path__ + "media/images/gift-1399b006370aa55d8bb867bc6536185c.svg";